/* window.siloScrollLock — the one page scroll lock for the video lightboxes (video-modal.js loads this file just
   before itself; the stream modal bundle imports it). The page never moves: <html> stops scrolling (overflow hidden;
   iOS 16+ honours it on the root) and the desktop scrollbar's width is padded back so nothing shifts sideways.
   The old position:fixed + scrollTo restore made the page jump to the top and smooth-scroll back down on close
   (html has scroll-behavior: smooth). Counted, so nested or repeated opens release cleanly. */
window.siloScrollLock = window.siloScrollLock || (() => {
  let depth = 0;
  return {
    lock() {
      if (depth++) return;
      const de = document.documentElement;
      const gap = window.innerWidth - de.clientWidth;
      de.style.overflow = 'hidden';
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
    },
    unlock() {
      if (!depth || --depth) return;
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
    },
  };
})();
